import React, { useEffect, useState } from 'react'
import {
  Avatar,
  Col,
  Input,
  Pagination,
  Row,
  Space,
  Table,
  Tooltip,
} from 'antd'
import { CellEclipseBox } from '../Common/Table'
import { inject, observer } from 'mobx-react'
import {
  CommentWrapper,
  NameUser,
  PaginationWrapper,
  TableSelectUserWrapper,
} from './TableSelectUserStyled'
import { apiUrl } from '../../config'
import { blue } from '../../color'
import { toJS } from 'mobx'
import { ASSIGNEE_TYPE } from '../../constants'
import authenticationStore from '../../stores/authenticationStore'
import { AppTable } from '../AppTable/AppTable'
import { AppTablePagination } from '../AppTable/AppTablePagination'
import { MagnifierOutlineIcon } from '../AppIcon'

const { Search } = Input

const TableSelectUser = props => {
  const {
    rowSelection,
    onSelectUser,
    userStore,
    loadingAnimationStore,
    selectUserStore,
    authenticationStore,
  } = props

  const {
    userList,
    userListTotalCount,
    setFilter,
    userListPageIndex,
    userListPageSize,
  } = userStore

  const { tableUserType, selectData } = selectUserStore

  const [disableUserList, setDisableUserList] = useState([])
  const [keywordSearch, setKeywordSearch] = useState()

  useEffect(() => {
    if (!tableUserType) return
    const assigneesListAll = [
      ...toJS(selectData.handler),
      ...toJS(selectData.combiner),
      ...toJS(selectData.follower),
      ...toJS(selectData.leader),
    ]
    const filterAssigneesListToId = tableDepartmentType =>
      assigneesListAll
        .filter(
          el =>
            el.assignee_type === ASSIGNEE_TYPE.USER &&
            el.permission !== tableDepartmentType
        )
        .map(el => el.id)
    if (tableUserType === 'handler') {
      setDisableUserList(filterAssigneesListToId(ASSIGNEE_TYPE.HANDLER))
    }
    if (tableUserType === 'combiner') {
      setDisableUserList(filterAssigneesListToId(ASSIGNEE_TYPE.COMBINER))
    }
    if (tableUserType === 'follower') {
      setDisableUserList(filterAssigneesListToId(ASSIGNEE_TYPE.FOLLOWER))
    }
    if (tableUserType === 'leader') {
      setDisableUserList(filterAssigneesListToId(ASSIGNEE_TYPE.LEADER))
    }
  }, [tableUserType])

  const tableColumn = [
    {
      title: 'Thông tin',
      render: record => (
        <CommentWrapper
          author={<NameUser>{record?.name_lowercase || ''}</NameUser>}
          avatar={
            <Avatar
              size={36}
              style={{ backgroundColor: blue }}
              src={
                record?.imageId
                  ? `${apiUrl}/api/v1/images/${record?.imageId}`
                  : undefined
              }>
              {record?.name_uppercase
                ? record.name_uppercase.split('')[0].toUpperCase()
                : ''}
            </Avatar>
          }
        />
      ),
    },
    {
      title: 'ID',
      render: record => record?.username,
    },
    {
      title: 'Chức vụ',
      render: record => (record.position ? record?.position.name : 'Chưa rõ'),
    },
    {
      title: 'Phòng ban',
      render: record => (
        <Tooltip title={record?.department?.name}>
          <CellEclipseBox>{record?.department?.name}</CellEclipseBox>
        </Tooltip>
      ),
    },
  ]

  const onSearchByUsername = keyword => {
    setFilter('userListPageIndex', 0)
    setFilter('userListKeyword', keyword)
    loadingAnimationStore.setTableLoading(true)
    userStore.getUserList().finally(() => {
      loadingAnimationStore.setTableLoading(false)
    })
  }

  const onChangePagination = (pageIndex, pageSize) => {
    setFilter('userListPageIndex', pageIndex - 1)
    setFilter('userListPageSize', pageSize)
    loadingAnimationStore.setTableLoading(true)
    userStore
      .getUserList()
      .finally(() => loadingAnimationStore.setTableLoading(false))
  }

  useEffect(() => {
    if (authenticationStore.currentUser) {
      setFilter('userListPageIndex', 0)
      setFilter('userListKeyword', undefined)
      setFilter('userListStatus', true)
      setFilter('companyCode', authenticationStore.currentCompanyCode())
      setKeywordSearch(undefined)
      loadingAnimationStore.setTableLoading(true)
      userStore
        .getUserList()
        .finally(() => loadingAnimationStore.setTableLoading(false))
    }
    return () => userStore.clearStore()
  }, [tableUserType, authenticationStore.currentUser])

  return (
    <TableSelectUserWrapper>
      <Row align={'middle'}>
        <Col span={24} md={24} lg={12}>
          <Search
            allowClear
            value={keywordSearch}
            placeholder="Tìm kiếm người dùng theo tên, id..."
            onChange={e => setKeywordSearch(e.target.value)}
            onSearch={onSearchByUsername}
            enterButton={
              <MagnifierOutlineIcon
                style={{ color: '#000', width: 16, height: 16 }}
              />
            }
            className="custom-search-input fixed-width"
          />
        </Col>
        <Col span={24} md={24} lg={12}>
          <AppTablePagination
            onChange={onChangePagination}
            total={userListTotalCount}
            pageSize={userListPageSize}
            current={userListPageIndex + 1}
            showSizeChanger={false}
            showQuickJumper={false}
            showLessItems
          />
        </Col>
      </Row>
      <AppTable
        rowSelection={{
          ...rowSelection,
        }}
        columns={tableColumn}
        dataSource={userList}
        rowKey={record => record.username}
        onRow={record => {
          return {
            onClick: () => onSelectUser(record),
          }
        }}
        rowClassName={record =>
          disableUserList.includes(record.username)
            ? 'disabled-row'
            : 'able-row'
        }
        pagination={false}
        loading={loadingAnimationStore.tableLoading}
        size={'small'}
      />
    </TableSelectUserWrapper>
  )
}

TableSelectUser.propTypes = {}

export default inject(
  'userStore',
  'userGroupStore',
  'loadingAnimationStore',
  'selectUserStore',
  'authenticationStore'
)(observer(TableSelectUser))
